import { render } from "./SidebarNavLink.vue?vue&type=template&id=32b7b594&scoped=true"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"

import "./SidebarNavLink.vue?vue&type=style&index=0&id=32b7b594&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b7b594"]])

export default __exports__